<template lang="pug">
header.header(:data-id="number")
  .left
    .logo
      img(:src="setLogo()")
      <!--img(src="@/assets/logo.svg")-->
    select(@change="jump", v-model="ids")
      option(v-for="(n, i) in sel", :value="n.value" :id="n.color")
        | {{ n.name }} {{ n.idCheck }}
    button.create(v-if="sets.length < 10", @click="create")
      img(src="@/assets/ico_plus.svg")
      | 新規作成
  Sizes
  .right
    .right-content(v-if="config.type == 'c'")
      button.btn.save(@click="showSaved")
        img(src="@/assets/ico_search.svg")
        | シミュレーションの復元
      button.btn.save(@click="showSaveArea")
        img(src="@/assets/ico_save.svg")
        | シミュレーション保存
      modal.save-simulation(name="save-simulation")
        .btn-close(@click="hideSaveArea")
          img(src="@/assets/ico_close.svg")
        SaveInput(
          @save="save",
          @saveId="saveId",
          @confirm="confirm",
          @submit="submit",
          @back="back",
          @close="hideSaveArea",
          :checkConfirm="checkConfirm",
          :checkConfirmEmail="checkConfirmEmail",
          :checkId="checkId",
          :errorEmail="errorEmail",
          :code="code"
        )
      modal.save-simulation(name="saved-area")
        .btn-close(@click="closeSaved")
          img(src="@/assets/ico_close.svg")
        SavedArea(@close="closeSaved", @submitSaved="submitSaved" :errorMessage="errorMessage")
      modal.save-simulation(name="success")
        .modal.success
          p 送信が完了しました。
          button.success-btn(@click="closeSuccess") 閉じる
          p.success-desc ※メールが届かない場合は、お手数ですが下記ご確認ください。
          div.success-desc
            p.success-child ・メールアドレスの入力を再度お試しください。<br>
            p.success-child ・迷惑メールフォルダをご確認ください。

    Total
    button.btn(@click="show")
      img(src="@/assets/ico_doc.svg")
      | 組合せ・見積り確認
    button.btn.logout(v-if="config.type === 'b'", @click="alertShow") ログアウト

  modal(name="modal-set", width="820", height="570")
    .btn-close(@click="hide")
      img(src="@/assets/ico_close.svg")
    ModalTotalSet(@close="hide")
  modal.modal-create(name="modal-create", width="980", height="670")
    ModalCreate(@close="createHide", :previd="previd", :nextid="nextid")
  modal.alert(name="logout-alert", width="450", height="200")
    ModalAlert(@close="alertHide")
</template>

<script>
import store from '../../stores';
import Sizes from './Sizes.vue';
import Total from './Total.vue';
import ModalCreate from '../create/ModalCreate.vue';
import ModalTotalSet from '../total/ModalTotalSet.vue';
import ModalAlert from '../parts/ModalAlert.vue';
import SaveInput from '../save/SaveInput.vue';
import SavedArea from '../save/SavedArea.vue';
import axios from 'axios';
export default {
  name: 'Header',
  components: {
    Total,
    Sizes,
    ModalTotalSet,
    ModalCreate,
    ModalAlert,
    SaveInput,
    SavedArea
  },
  data () {
    return {
      errorEmail: false,
      timer: {},
      ids: 1,
      previd: 0,
      nextid: 0,
      set: {},
      space: [],
      sel: [],
      parts2: [],
      parts1: [],
      checkConfirm: false,
      checkConfirmEmail: false,
      checkId: false,
      errorMessage: false,
      code: null
    };
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
      if (this.$store.state.checkSet[0]) {
        this.checkId = false;
      }
    }
  },
  methods: {
    update () {
      let me = this;
      if (me.sets[me.number] !== undefined) {
        me.numbers = me.number + 1;
        me.set = me.sets[me.number];
        me.space = me.set.space;
        me.sel = [];
        for (let prop in me.sets) {
          let cnt = 0;
          if (me.sets[prop] !== undefined) {
            for (let i = 0; i < Number(prop); i++) {
              if (me.sets[prop].name === me.sets[i].name) {
                cnt++;
              }
            }
            let obj = {};
            if (cnt === 0) {
              obj.name = me.sets[prop].name;
              obj.color = me.sets[prop].color;
            } else {
              obj.name = me.sets[prop].name + '(' + (cnt + 1) + ')';
              obj.color = me.sets[prop].color;
            }
            // name1
            me.sets[prop].name1 = obj.name;
            // name1
            obj.value = Number(prop) + 1;
            me.sel[prop] = obj;
          }
        }
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.ids = me.number + 1;
        }, 100);
      }

      if (me.sets.length === 0) {
        me.createShow();
      }
    },
    jump (e) {
      store.commit('setView', 0);
      this.previd = Number(e.target.value);
      this.$router.push({ path: '/' + e.target.value });
      store.commit('setId', e.target.value);
      let idx = Number(e.target.value - 1);
      let col = Number(this.sel[idx].color);
      store.commit('setIdx', idx);
      store.commit('setColor', col);
      store.commit('setcheckColor', col);
      setTimeout(function () {
        store.commit('setView', 1);
      }, 1000);
      // this.sets.splice(this.number, 1, this.set);
    },
    save (data) {
      const url = '/api/simulations';
      // data.simulations.sets.push(this.sets);
      // if (this.$store.state.simulationInfo.id) {
      //   if (this.$store.state.idx > this.sets.length - 1 || this.previd > this.sets.length - 1) {
      //     if (this.previd === this.sets.length) {
      //       data.simulations.sets.push(this.$store.state.arraybk ? this.$store.state.arraybk : this.sets);
      //     } else {
      //       data.simulations.sets = [];
      //     }
      //   }
      //   data.simulations.sets.push(this.$store.state.arraybk ? this.$store.state.arraybk : this.sets);
      // }
      if (this.$store.state.simulationInfo.id && this.sets.length >= 2) {
        data.simulations.sets.push(this.$store.state.arraybk);
      } else {
        data.simulations.sets.push(this.sets);
      }
      data.simulations.sets = [this.$store.state.sets];
      store.commit('setCheckSet', data.simulations.sets);
      axios.post(this.config.baseURL + url, data.simulations, this.axiosConfig).then(
        (response) => {
          this.code = response.data.code;
          this.checkId = !this.checkId;
          return true;
        }).catch((error) => {
        if (error.response) {
          console.log('error');
          return false;
        }
      });
    },
    saveId () {
      this.checkId = false;
      this.checkConfirm = !this.checkConfirm;
    },
    showSaved () {
      this.$modal.show('saved-area');
    },
    closeSaved () {
      this.$modal.hide('saved-area');
      if (this.sets.length <= 0) {
        this.$modal.show('modal-create');
      }
      this.errorMessage = false;
    },
    submitSaved (id) {
      const url = '/api/simulations/' + id;
      const tmp = [];
      let vm = this;
      axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
        store.commit('setView', 0);
        response.data.simulations.simulation_detail.forEach((simulation) => {
          tmp.push(simulation.set);
        });
        store.commit('setSets', tmp);
        store.commit('setColor', tmp[0].color);
        const simulationInfo = response.data.simulations;
        store.commit('setSimulationInfo', simulationInfo);
        vm.checkConfirm = false;
        vm.errorMessage = false;
        vm.$modal.hide('saved-area');
        store.commit('setId', 1);
        setTimeout(function () {
          store.commit('setView', 1);
        }, 1000);
        return true;
      }).catch((error) => {
        vm.errorMessage = true;
        console.log(error);
        return false;
      });
    },
    closeSuccess () {
      this.$modal.hide('success');
    },
    showSaveArea () {
      this.errorEmail = false;
      this.$modal.show('save-simulation');
    },
    hideSaveArea () {
      this.$modal.hide('save-simulation');
      this.checkConfirmEmail = false;
      this.checkConfirm = false;
    },
    back () {
      this.checkConfirmEmail = false;
      this.checkConfirm = true;
    },
    confirm () {
      this.checkConfirmEmail = true;
      this.checkConfirm = false;
    },
    submit (data) {
      let vm = this;
      const url = '/api/simulations/' + this.code + '/send-mail';
      axios.post(this.config.baseURL + url, data, this.axiosConfig).then(
        (response) => {
          vm.checkConfirmEmail = false;
          vm.$modal.hide('save-simulation');
          vm.$modal.show('success');
          return true;
        }).catch((error) => {
        if (error.response) {
          console.log('error');
          vm.errorEmail = true;
          return false;
        }
      });
    },
    show () {
      this.$modal.show('modal-set');
    },
    hide () {
      this.$modal.hide('modal-set');
    },
    createShow () {
      this.previd = Number(this.number);
      this.nextid = Number(this.sets.length) + 1;
      this.$modal.show('modal-create');
    },
    create () {
      let me = this;
      clearTimeout(me.timer);
      me.timer = setTimeout(function () {
        me.createShow();
      }, 100);
    },
    createHide () {
      this.$modal.hide('modal-create');
    },
    alertShow () {
      this.$modal.show('logout-alert');
    },
    alertHide (n) {
      if (n === 'yes') {
        let url = '/api/logout';
        if (this.config.type === 'b') {
          this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        }
        axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
          localStorage.removeItem('token');
          localStorage.removeItem('user_id');
          window.location.href = '/login';
        }).catch(function (error) {
          console.log(error);
        });
      }
      this.$modal.hide('logout-alert');
    },
    setLogo () {
      if (this.loginUser.company_code !== undefined) {
        let company = this.loginUser.company_code;
        return './static/img/' + company + '.png?rnd=' + Math.round(Math.random() * 1000000);
      } else {
        return this.config.logo;
      }
    }
  },
  created () {
    if (this.sets[this.number] !== undefined) {
      this.set = this.sets[this.number];
      this.space = this.sets[this.number].space;
    }
  },
  mounted () {
    let me = this;
    if (this.sets.length === 0) {
      me.previd = 1;
      me.nextid = 1;
      store.commit('setId', 1);
      clearTimeout(me.timer);
      me.timer = setTimeout(function () {
        me.createShow();
      }, 100);
    }
  }
};
</script>

<style lang="stylus">
.header {
  position: absolute;
  left: 0;
  width: 100%;
  height: 51px;
  border-bottom: 1px solid #DDDDDD;
  background-color: #FFFFFF;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.left {
  display: flex;
  align-items: center;
}

.logo {
  margin-right: 15px;
  padding: 0px;
  img {
    pointer-events: none;
    height: 30px;
  }
}

select {
  width: 180px;
  background: url('../../assets/ico_arrow_down.svg') no-repeat right 5px center;
  font-size: 12px;
}

.create, .search {
  font-weight: bold;
  font-size: 12px;
  margin-left: 15px;
  cursor: pointer;
  text-decoration: none;
  color: #000;
  img {
    display: inline-block;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 5px;
    pointer-events: none;
  }
}

.search {
  margin-left: 10px;
}

.right {
  display: flex;
  align-items: center;

  .save {
    margin-right: 10px;
  }

  .total {
    display: flex;
    align-items: center;
    font-size: 10px;
    border: 1px solid #DDDDDD;
    padding: 9px 15px;
    border-radius: 5px;
    font-weight: bold;

    .price {
      width: 70px;
      color: #FF4E00;
      text-align: right;
    }
  }

  .btn {
    background-color: #2E7C80;
    color: #FFFFFF;
    font-weight: bold;
    border: none;
    border-radius: 5px;
    padding: 10px 15px;
    margin-left: 10px;
    cursor: pointer;

    img {
      display: inline-block;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 5px;
    }
  }

  .save-simulation {
    .vm--modal {
      width: 570px !important;
      height: 300px !important;
    }
  }

  .right-content {
    display: flex;
  }
}

.btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.success {
  text-align: center;
  margin: 60px 0;
}
.success-btn {
  background-color: #999;
  width: 150px;
  height: 33px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 20px;
}
.success-child-content {
  margin: 0;
}
.success-desc {
  margin: 0 auto;
}
.success-desc:last-child {
  margin: 0 0 0 50px;
  text-align: left;
}
.success-child {
  margin: 0 0 0 15px;
}
.modal {
  h2 {
    margin: 0;
    padding: 20px 30px;
    font-size: 20px;
    border-bottom: 1px solid #DDDDDD;
  }

  .content {
    padding: 20px 30px;
  }
}

.vm--container, .vm--overlay {
  width: auto !important;
  height: auto !important;
  right: 0;
  bottom: 0;
}

.vm--modal {
  margin: auto !important;
  position: absolute !important;
  width: auto !important;
  height: auto !important;
  max-width: 980px !important;
  max-height: 670px !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
}

.alert {
  .vm--modal {
    width: 450px !important;
    height: 200px !important;
  }
}

.logout {
  background-color: #999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue